import { FreeGift } from '@/components/blocks/FreeGiftV2';
import { useProducts } from '@/data/Content/Products';
import { PromoIconResponse } from '@/data/Content/PromoMessage';
import { ProductType } from '@/data/types/Product';
import { CombinablePromotion } from '@/data/types/Promotions';
import { useMemo } from 'react';

interface PromotionContainerProps {
	promoData: PromoIconResponse;
	partNumber: string;
	isReward?: boolean;
}

export const PromotionContainer = ({
	promoData: allPromotions,
	partNumber,
	isReward = false,
}: PromotionContainerProps) => {
	const combinableItemsPartNumbers = useMemo<string[]>(
		() => [
			...new Set([
				...((allPromotions?.combinablePromotions ?? []) as CombinablePromotion[]).flatMap(
					(item) => [
						...(item.reward?.targetSKUs ?? []).map(({ sku }) => sku),
						...(item.purchase?.triggerSKUs ?? []).map(({ sku }) => sku),
					]
				),
				...(partNumber ? [partNumber] : []),
			]),
		],
		[allPromotions?.combinablePromotions, partNumber]
	);

	const { products: fetchedProducts, loading: productsLoading } = useProducts({
		id: combinableItemsPartNumbers,
		condition: combinableItemsPartNumbers?.length > 0,
	});

	const items = useMemo<ProductType[]>(
		() => fetchedProducts?.filter((product): product is ProductType => Boolean(product)) ?? [],
		[fetchedProducts]
	);

	if (productsLoading || items.length < 1) return null;

	const combinablePromotions = allPromotions?.combinablePromotions;

	return (
		<FreeGift
			items={items}
			currentPartNumber={partNumber}
			combinablePromotions={combinablePromotions}
			isRewardView={isReward}
		/>
	);
};
